import * as React from "react";
const SvgFiRrShrimp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shrimp_svg__a)">
      <path
        fill="#062147"
        d="M14 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m10 17a3 3 0 0 1-3 3h-9c-6.573.157-12.159-5.708-12-12.225A12.247 12.247 0 0 1 12.365 0L23 .023a1 1 0 1 1 0 2h-1.065A7.89 7.89 0 0 1 13.815 9c-1.44 0-2.844.447-4.02 1.278A2.88 2.88 0 0 0 12 11a1 1 0 1 1 0 2 4.74 4.74 0 0 1-3.653-1.35A6.3 6.3 0 0 0 7.2 13.945 3.68 3.68 0 0 0 10 15a1 1 0 0 1 1 1c-.163 1.87-3.22.675-3.943.307A6.516 6.516 0 0 0 13.5 22c1.31-1.023 5.442-4 7.5-4a3 3 0 0 1 3 3M11 4.5A2.59 2.59 0 0 0 14 7a6.01 6.01 0 0 0 5.915-4.983L13.476 2A2.5 2.5 0 0 0 11 4.5M4.5 5.51a4.08 4.08 0 0 0 3.625 3.53 9 9 0 0 1 2.221-1.34 4.48 4.48 0 0 1-.795-5.316 10.5 10.5 0 0 0-5.05 3.127m2.04 14.872a8.34 8.34 0 0 1-1.515-5.4 5.3 5.3 0 0 1-2.677-.367 10.04 10.04 0 0 0 4.191 5.767m0-9.65a6.15 6.15 0 0 1-3.48-3.1A9.56 9.56 0 0 0 2 11.793c.231.439 1.081 1.58 3.425 1.115a8.4 8.4 0 0 1 1.117-2.174zM22 21c-.4-2.2-2.947-.233-4.95 1H21a1 1 0 0 0 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shrimp_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShrimp;
